import { render, staticRenderFns } from "./dialogBox.vue?vue&type=template&id=1e8a4190&scoped=true"
import script from "./dialogBox.vue?vue&type=script&lang=js"
export * from "./dialogBox.vue?vue&type=script&lang=js"
import style0 from "./dialogBox.vue?vue&type=style&index=0&id=1e8a4190&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a4190",
  null
  
)

export default component.exports